export const GET_PRODUCTION_PROCESS = 'GET_PRODUCTION_PROCESS';
export const GET_PRODUCTION_PROCESS_SUCCESS = 'GET_PRODUCTION_PROCESS_SUCCESS';
export const GET_PRODUCTION_PROCESS_FAILED = 'GET_PRODUCTION_PROCESS_FAILED';

export const GET_PRODUCTION_PROCESS_BY_ID = 'GET_PRODUCTION_PROCESS_BY_ID';
export const GET_PRODUCTION_PROCESS_BY_ID_SUCCESS = 'GET_PRODUCTION_PROCESS_BY_ID_SUCCESS';
export const GET_PRODUCTION_PROCESS_BY_ID_FAILED = 'GET_PRODUCTION_PROCESS_BY_ID_FAILED';

export const CREATE_PRODUCTION_PROCESS = 'CREATE_PRODUCTION_PROCESS';
export const CREATE_PRODUCTION_PROCESS_SUCCESS = 'CREATE_PRODUCTION_PROCESS_SUCCESS';
export const CREATE_PRODUCTION_PROCESS_FAILED = 'CREATE_PRODUCTION_PROCESS_FAILED';

export const UPDATE_PRODUCTION_PROCESS = 'UPDATE_PRODUCTION_PROCESS';
export const UPDATE_PRODUCTION_PROCESS_SUCCESS = 'UPDATE_PRODUCTION_PROCESS_SUCCESS';
export const UPDATE_PRODUCTION_PROCESS_FAILED = 'UPDATE_PRODUCTION_PROCESS_FAILED';

export const DELETE_PRODUCTION_PROCESS = 'DELETE_PRODUCTION_PROCESS';
export const DELETE_PRODUCTION_PROCESS_SUCCESS = 'DELETE_PRODUCTION_PROCESS_SUCCESS';
export const DELETE_PRODUCTION_PROCESS_FAILED = 'DELETE_PRODUCTION_PROCESS_FAILED';
